module.exports = "<logout></logout>";


//////////////////
// WEBPACK FOOTER
// ./src/component/logout/logoutIndex.html
// module id = 196
// module chunks = 0